// extracted by mini-css-extract-plugin
module.exports = {"plan":"ShoppingCart_plan__WbQLT","plan__name":"ShoppingCart_plan__name__KyCBH","plan__price":"ShoppingCart_plan__price__EqaEn"};